import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Pages
import Home from './pages/Home';
import CWH from './pages/CWH';
import Spurt from './pages/Spurt';
import Yori from './pages/Yori';
import Sniwwoc from './pages/Sniwwoc';
import Gaudi from './pages/Gaudi';
import Milchee from './pages/Milchee';

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Home />}>
        </Route>
        <Route path='/cwh' element={<CWH />}>
        </Route>
        <Route path='/spurt' element={<Spurt />}>
        </Route>
        <Route path='/yori' element={<Yori />}>
        </Route>
        <Route path='/sniwwoc' element={<Sniwwoc />}>
        </Route>
        <Route path='/gaudi-magazine' element={<Gaudi />}>
        </Route>
        <Route path='/milchee' element={<Milchee />}>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
